import logo from "assets/images/brands/brand-main-sm.png";
// import smLogo from "assets/images/brands/brand-main-sm.png";
import whitLogo from "assets/images/brands/brand-main-sm-light.png";


export const clientName = "EM";
export const developedBy = "EM";

export const imagesUrl = process.env.REACT_APP_API_IMAGES_URL;
export const cpUrl = process.env.REACT_APP_CP_URL;
export const apiUrl = process.env.REACT_APP_API_URL;
export const companyName =  "EM";
export const sidebarLogo = whitLogo;
export const mainLogo = logo;
export const lightLogo = whitLogo;
